import PropTypes from 'prop-types';
import colors from '../../theme/colors';

const variantStyles = {
  primary: { backgroundColor: `${colors.primary}18`, color: colors.primary },
  success: { backgroundColor: `${colors.success}18`, color: colors.success },
  warning: { backgroundColor: 'rgba(217, 119, 6, 0.1)', color: '#d97706' },
  danger: { backgroundColor: 'rgba(220, 38, 38, 0.1)', color: '#dc2626' },
  gray: { backgroundColor: 'rgba(107, 114, 128, 0.1)', color: '#6b7280' },
};

const Badge = ({ variant = 'primary', children, icon: Icon = null }) => (
  <span
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '6px',
      padding: '4px 10px',
      borderRadius: '9999px',
      fontSize: '0.75rem',
      fontWeight: 600,
      ...variantStyles[variant],
    }}
  >
    {Icon && <Icon size={14} />}
    {children}
  </span>
);

Badge.propTypes = {
  variant: PropTypes.oneOf(['primary', 'success', 'warning', 'danger', 'gray']),
  children: PropTypes.node.isRequired,
  icon: PropTypes.elementType,
};

export default Badge;
